<template>
  <div class="oddt">
    <div class="box">
      <div class="title">Order</div>
      <div class="num">
        <span>Order No</span>
        <span>{{ orderDetails.sn }}</span>
      </div>
      <div class="num">
        <span class="am">Total Amount</span>
        <span>¥{{ orderDetails.totalPrice ? orderDetails.totalPrice : 0 }}</span>
      </div>
      <div class="num">
        <span>Telephone</span>
        <span>{{ orderDetails.phone }}</span>
      </div>
      <div class="num">
        <span>Create Time</span>
        <span>{{ orderDetails.createTime }}</span>
      </div>
      <template v-if="orderDetails.itemList && orderDetails.itemList.some(v => v.attrList.some(v1 => v1.imageUrl))">
        <div class="num">
          <span>ID photo</span>
          <div class="certificates-ima-box" v-for="item in orderDetails.itemList" :key="item.itemId">
            <img v-for="v1 in item.attrList" :key="v1.id" :src="`${VUE_APP_BASE_URL}/openapi/web/image/download/${v1.imageUrl}`" alt="">
          </div>
      </div>
      </template>

    </div>
  </div>
</template>

<script>
export default {
  name: "oddt",
  props: ['orderDetails'],
  data() {
    return {
      VUE_APP_BASE_URL: process.env.VUE_APP_BASE_URL,
    }
  },
};
</script>

<style scoped lang='less'>
.oddt {
  padding: 0.533333rem 0.32rem;
  border-top: 1px dashed #A1A6BA;
  .box {
    padding: 0 0.133333rem 0;
    font-size: .426667rem;
    color: #333333;
  }
  .title {
    color: #222328;
    font-size: 0.24rem * 2;
    font-weight: bold;
  }
  .num{
    margin-top: .32rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;
    span:first-child{
      // width: 4em;
      font-size: 0.35rem;
      color: #666;
    }
    span:last-child{
      // flex: 1;
      font-size: 0.35rem;
      padding-left: 0.1rem;
      color: #333;
    }
    .certificates-ima-box{
      flex: 1;
      padding-left: 0.5rem;
    }
  }
}
</style>
